import { render, staticRenderFns } from "./Wc.vue?vue&type=template&id=e85ec790"
import script from "./Wc.vue?vue&type=script&lang=js"
export * from "./Wc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports